/* 
CopyrightÂ© Celligence International, LLC - 2023

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/
import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { Container, createTheme, ThemeProvider } from "@mui/material";
import {AngelSignAdmin} from "morgan-sign-admin";

import WelcomePage from "./Pages/WelcomePage";
import ErrorPage from "./Pages/ErrorPage";
import FinishPage from "./Pages/FinishPage";

function App() {

  const cursor = "default";
  const [searchParams] = useSearchParams();

   const core = process.env.REACT_APP_RESTSERVER;
   const baseAngelSignUrl = `${core}/live/ai-sign`;
   const adminConfig = {
     publicUrl: process.env.REACT_APP_PUBLIC_URL,
     imagingEndpoint: `${core}/image`,
     esignHandlerEndpoint: `${baseAngelSignUrl}/esignHandler`,
     esignDocGroupEndpoint: `${baseAngelSignUrl}/esignDocGroup`,
     esignDocInfoEndpoint: `${baseAngelSignUrl}/esignDocInfo`,
     adminPanelEndpoint: `${baseAngelSignUrl}/admin-panel`,
     sessionEndpoint: `${core}/session`,
     sessionStatusEndpoint: `${core}/session/status`,
     maxMindEndpoint: process.env.REACT_APP_MAXMIND,
     zipCodeEndpoint: `${core}/zipcode`,
   };
  
  const resolveThemePath = () => {
    const themePath = "./Assets/Themes/";
    let themeName = "default";
    let fullThemePath = `${themePath}${themeName}.json`;

    try {
      if (searchParams.get("t") !== null) {
        themeName = searchParams.get("t");
        fullThemePath = `${themePath}${themeName}.json`;
      }
    } catch (e) {
      console.error(e);
    }   
    return fullThemePath;
  };

  useEffect(() => {
    console.log('Build version: ES-2026-005');
  }, []);

  const theme = createTheme(resolveThemePath());
  //"#E9E9E9"
  return (
    <div style={{
      position: "fixed",
      height: "100vh",
      width: "100vw",
      backgroundColor: "#E9E9E9",
      cursor: cursor,
    }}>
      <ThemeProvider theme={theme}>
        <Container disableGutters={true} maxWidth={false}>
          <Routes>
            <Route path="welcome/:hashkey" element={<WelcomePage />} />
            <Route path="finish" element={<FinishPage />} />
            <Route path="error" element={<ErrorPage />} />
            <Route path="/" element={<AngelSignAdmin {...adminConfig} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Container>
      </ThemeProvider>
    </div>
  );
}

export default App;
